import {Col, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import ComposeEmailModal from "../client/ComposeEmailModal";
import {AppContext} from "../../lib/AppContext";
import MDButton from "../../components/MDButton";
import {Chip, FormControl, InputAdornment, InputLabel, NativeSelect, OutlinedInput} from "@mui/material";
import * as pagination from "../common/pagination";
import {getCommunicationTemplates, massTags} from "../common/api/WebApi";
import Checkbox from "@mui/material/Checkbox";

export default function ActionItem({actionType, actionUsers, defaultSelected, callback}) {
  const [context, setContext] = useContext(AppContext);
  const [actionContinue, setActionContinue] = useState(false);
  const [actionLabel, setActionLabel] = useState('');
  const [emailTemplate, setEmailTemplate] = useState(null);
  const [actionEmail, setActionEmail] = useState(false);
  const [actionTags, setActionTags] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    if (defaultSelected?.length > 0) {
      setSelectedRows(defaultSelected);
      setAllSelected(true);
    }
  }, [defaultSelected]);

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(actionUsers.map(row => row.guid));
    }
    setAllSelected(!allSelected);
  }

  const toggleRow = (guid) => {
    setSelectedRows(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const handleRowSelected = React.useCallback(state => {
    let selected = [];
    for (let j in state.selectedRows) {
      selected.push(state.selectedRows[j].guid)
    }
    setSelectedRows(selected);
  }, []);

  useEffect(() => {
    setActionEmail(false);
    setActionTags(false);
    if ('composeEmail' === actionType) {
      setActionLabel('Choose Email Recipients');
      setActionEmail(true);
    } else if ('addTags' === actionType) {
      setActionLabel('Add Tags');
      setActionTags(true)
    }
  }, [actionType])

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [sortDir, setSortDir] = useState('asc');
  const [sortOrder, setSortOrder] = useState('lastName');
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [saving, setSaving] = useState(false);
  const [emailTemplates, setEmailTemplates] = useState([]);

  const getCompanyTemplates = async () => {
    getCommunicationTemplates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEmailTemplates(result);
      }
    });
  }
  useEffect(() => {
    if (!actionEmail) {
      return;
    }
    getCompanyTemplates();
  }, [actionEmail])

  const [tagName, setTagName] = useState('');
  const [tags, setTags] = useState([]);
  const handleTagChange = (e) => {
    setTagName(e.target.value);
  }

  const addTag = (tag) => {
    let _tags = [...tags];
    if (_tags.indexOf(tag) === -1) {
      _tags.push(tag);
      setTags(_tags);
    }
    setTagName('');
  }

  const removeTag = (tag) => {
    let idx = -1;
    for (let j in tags) {
      if (tags[j] === tag) {
        idx = j;
      }
    }
    if (idx > -1) {
      let _tags = [...tags];
      _tags.splice(idx, 1);
      setTags(_tags);
    }
  }

  const saveMassTags = () => {
    let massTagRequest = {
      recipientGuids: selectedRows,
      tags: tags
    }
    setSaving(true);
    massTags(massTagRequest).then((resp) => {
      let _context = {...context};
      _context.toast = {
        message: 'Tags Saved!',
        type: 'success'
      }
      setSaving(false);
      setContext({..._context});
      setSelectedRows([]);
      callback()
    });
  }

  const MemberTable = () => {
    return <table className={'table table-striped'}>
      <thead>
      <tr>
        <th><Checkbox checked={allSelected}
                      onChange={() => {
                        toggleSelectAll();
                      }}
        /></th>
        <th>Member</th>
        <th>Email</th>
      </tr>
      </thead>
      <tbody>
      {actionUsers?.map((member, idx) => {
        return (<tr key={idx}>
          <td>
            <Checkbox checked={selectedRows.includes(member.guid)}
                      onChange={() => {
                        toggleRow(member.guid);
                      }}
            />
          </td>
          <td>
            {member.firstName} {member.lastName}
          </td>
          <td>
            {member.email}
          </td>
        </tr>)
      })}
      </tbody>
    </table>
  }

  return (
    <>
      {actionContinue && actionEmail &&
        <ComposeEmailModal show={true}
                           emailTemplate={emailTemplate}
                           recipients={selectedRows}
                           saving={false}
                           handleClose={() => {
                             setActionContinue(false);
                             setSelectedRows([]);
                             setAllSelected(false);
                           }} handleSave={() => {
          let _context = {...context};
          _context.toast = {
            message: 'Email Sent!',
            type: 'success'
          }
          setContext({..._context});
          setSelectedRows([]);
          callback()
        }}/>
      }
      {!actionContinue && actionTags && <>
        <Modal onHide={callback} size={'lg'} show={true}>
          <Modal.Header closeButton>
            <Modal.Title>{actionLabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Row>

              <Col>
                <FormControl variant="outlined" p={0}
                             className="form-inline d-block mt-2 mb-2">
                  <InputLabel shrink={true} htmlFor="tag-input" style={{
                    background: '#fff',
                    padding: '0 6px'

                  }}>Tag</InputLabel>
                  <OutlinedInput
                    autoFocus
                    autoComplete={'off'}
                    id="tag-input"
                    type={'text'}
                    value={tagName}
                    onChange={handleTagChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <MDButton
                          color="primary"
                          size="small"
                          disabled={!tagName}
                          onClick={() => {
                            addTag(tagName);
                          }}
                          className={'btn btn-primary'}
                        >Add</MDButton>
                      </InputAdornment>
                    }
                    label="Tag"
                  />
                </FormControl>
                {tags?.map((tag, idx) => {
                  return (<Chip variant="outlined" label={tag} key={idx} onDelete={() => {
                      removeTag(tag)
                    }} className={'mr-2'}/>
                  )
                })
                }
              </Col>

            </Row>

            <MemberTable />

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="button" color="info"
                      disabled={selectedRows?.length === 0 || tags?.length === 0 || saving}
                      onClick={() => {
                        saveMassTags()
                      }}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </Modal>
      </>
      }
      {!actionContinue && actionEmail && <>
        <Modal onHide={callback} size={'lg'} show={true}>
          <Modal.Header closeButton>
            <Modal.Title>{actionLabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Row>
              <Col className={'col col-12'} xs={12}>
                <label htmlFor="emailTemplate" className={"native-label"}>Email Template</label>
                <NativeSelect
                  onChange={(e) => {
                    if (parseInt(e.target.value, 10) === -1) {
                      setEmailTemplate(null);
                      return;
                    }
                    emailTemplates.forEach((t) => {
                      if (t.id === parseInt(e.target.value, 10)) {
                        setEmailTemplate(t);
                      }
                    })
                  }}
                  variant="outlined"
                  id={'emailTemplate'} name={'emailTemplate'} className={'form-control'}>
                  <option value={-1}>
                    Blank Email
                  </option>
                  {
                    emailTemplates?.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>
              </Col>
            </Row>

            <MemberTable />

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="button" color="info"
                      disabled={selectedRows?.length === 0}
                      onClick={() => {
                        setActionContinue(true);
                      }}>
              Continue
            </MDButton>
          </Modal.Footer>
        </Modal>
      </>}
    </>
  )
}